import { AlertController } from 'ionic-angular';
import { Apollo } from 'apollo-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage';

import { Task, TaskQL, TaskData, TaskNote } from './models';
import { TASKS_QUERY } from './queries';
import { ENV } from '../../environments/environment';
import { User } from './../auth/models';
import { AuthProvider } from './../auth/auth';
import { UtilsProvider } from './../utils/utils';
import { StorageProvider } from './../utils/storage';
import { getValue } from './filters';

export class GetTechnicianAvailabilityPayloadInput { snn: string; date: number}
@Injectable()
export class TasksProvider {
  private tasksQL: TaskQL[];
  private tasksData: TaskData[] = [];
  private hiddenTasks: string[] = [];
  private selectedTask: TaskQL;
  private threeDays: number = ((1000 * 60 * 60) * 72);
  private oneHour: number = 1000 * 60 * 60;
  private tenminutes: number = 1000 * 10 * 60;
  private allowedContactTime: number = this.threeDays;
  private queryList: any = {};

  constructor(
    public http: HttpClient,
    private apollo: Apollo,
    private utils: UtilsProvider,
    private authProvider: AuthProvider,
    private utilsProvider: UtilsProvider,
    private storageProvider: StorageProvider,
    private storage: Storage,
    private alertCtrl: AlertController
  ) {
    this.storage
      .get('tasksData')
      .then(result => {
        this.tasksData = result ? result : {};
      })
      .catch(e => console.log(e));
    this.storage
      .get('hiddenTasks')
      .then(result => {
        this.hiddenTasks = result ? result : [];
      })
      .catch(e => console.log(e));
  }

  public getTasks(
    params: {
      lookAfter?: any;
      lookBefore?: any;
      limit?: number;
      statuses?: string[];
      fullText?: string;
      contract?: string;
      startDate?: number;
      endDate?: number;
      sortFilter?: any;
      filters?: any;
    } = {
      lookAfter: null,
      lookBefore: null,
      startDate: 0,
      endDate: new Date().setHours(23, 59, 59, 999),
      limit: null,
      fullText: null,
      contract: null,
      statuses: [],
      sortFilter: { field: 'createdDate', direction: 'DESC' },
      filters: null
    },
    currentUser: boolean = true
  ) {
    return Observable.create(obs => {
      if (!params.statuses || params.statuses.length === 0) delete params.statuses; // = [Task.StatusEnum.Cancelled,Task.StatusEnum.Closed,Task.StatusEnum.Deleted,Task.StatusEnum.Inprogress,Task.StatusEnum.New,Task.StatusEnum.Open,Task.StatusEnum.Pending,Task.StatusEnum.Pending,Task.StatusEnum]
      let filter = {
        ...params
      };

      if (!filter.sortFilter)
        filter.sortFilter = {
          field: 'assignedDate',
          direction: 'ASC'
        };

      const defaultFilters = {
        userId: { _in: this.authProvider.getUserId() }
      };

      if(currentUser) filter.filters = { ...params.filters, ...defaultFilters };

      const hasQueryBeenCalledBefore = this.storageProvider.hasQueryBeenCalledBefore({ getTasks: {...filter} });
      if (hasQueryBeenCalledBefore) { 
        obs.next({ ...hasQueryBeenCalledBefore });

      } else {
        this.authProvider.initGraphQL().subscribe(graphResult => {
          this.apollo
            .query<any>({
              query: TASKS_QUERY,
              variables: filter
            })
            .subscribe(
              r => {
                const tasksQL = [...(r as any).data.tasks.items];
                const info = r.data.tasks;
                  if(currentUser){
                    this.tasksQL = tasksQL;
                    this.syncTasksData();
                  }

                  const payload = {
                    items: tasksQL,
                    totalCount: info.totalCount,
                    nextLookAfterKey: info.nextLookAfterKey,
                    previousLookBeforeKey: info.previousLookBeforeKey
                  }

                  this.storageProvider.setCachedQueryData({ getTasks: {...filter} }, payload);
                  obs.next(payload);
              },
              e => {
                this.utils.handleGraphError(e, true);
                obs.error(e);
              }
            );
        },
        error => { obs.error(error); }
      )};
    });
  }

  public syncTasksData() {
    // TODO syncing
    for (var key in this.tasksData) {
      if (this.tasksData.hasOwnProperty(key)) {
        const hasTask: boolean =
          this.tasksQL.filter(taskQL => {
            return taskQL.id === key;
          }).length > 0;

        if (!hasTask) {
          delete this.tasksData[key];
        }
      }
    }

    this.storage.set('tasksData', this.tasksData);
  }

  public getTasksA(
    params: {
      lookAfter?: any;
      lookBefore?: any;
      limit?: number;
      statuses?: string[];
      fullText?: string;
      contract?: string;
      startDate?: number;
      endDate?: number;
      sortFilter?: any;
      filters?: any;
    } = {
      lookAfter: null,
      lookBefore: null,
      startDate: 0,
      endDate: new Date().setHours(23, 59, 59, 999),
      limit: null,
      fullText: null,
      contract: null,
      statuses: [],
      sortFilter: { field: 'createdDate', direction: 'DESC' },
      filters: null
    },
    currentUser: boolean = true
  ) {
    return Observable.create(obs => {
      if (!params.statuses || params.statuses.length === 0) delete params.statuses; // = [Task.StatusEnum.Cancelled,Task.StatusEnum.Closed,Task.StatusEnum.Deleted,Task.StatusEnum.Inprogress,Task.StatusEnum.New,Task.StatusEnum.Open,Task.StatusEnum.Pending,Task.StatusEnum.Pending,Task.StatusEnum]
      let filter = {
        ...params
      };

      if (!filter.sortFilter)
        filter.sortFilter = {
          field: 'createdDate',
          direction: 'ASC'
        };

      const defaultFilters = {
        userId: { _in: this.authProvider.getUserId() }
      };

      // if(currentUser) filter.filters = { ...params.filters };
      const hasQueryBeenCalledBefore = this.storageProvider.hasQueryBeenCalledBefore({ getTasksA: {...filter} });
      if (hasQueryBeenCalledBefore) { 
        obs.next({ ...hasQueryBeenCalledBefore });

      } else {
        this.authProvider.initGraphQL().subscribe(graphResult => {
            this.apollo
              .query<any>({
                query: TASKS_QUERY,
                variables: filter
              })
              .subscribe(
                r => {
                  const tasksQL = [...(r as any).data.tasks.items];
                  const info = r.data.tasks;
                    if(currentUser){
                      this.tasksQL = tasksQL;
                      this.syncTasksData();
                    }

                    const payload = {
                      items: tasksQL,
                      totalCount: info.totalCount,
                      nextLookAfterKey: info.nextLookAfterKey,
                      previousLookBeforeKey: info.previousLookBeforeKey
                    }

                    this.storageProvider.setCachedQueryData({ getTasks: {...filter} }, payload);
                    obs.next(payload);
                },
                e => {
                  this.utils.handleGraphError(e, true);
                  obs.error(e);
                }
              );
          },
          error => {
            obs.error(error);
          });
      }
    });
  }

  public getTask(id: string) {
    return Observable.create(obs => {
      const hasQueryBeenCalledBefore = this.storageProvider.hasQueryBeenCalledBefore({ getTask: { id } });
      if (hasQueryBeenCalledBefore) { 
        obs.next({ ...hasQueryBeenCalledBefore });

      } else {
        this.authProvider.getOptions().subscribe(options => {
          let api = ENV.api + '/api/tasks/' + id;
          this.http.get(api, options).subscribe(
            result => {
              this.storageProvider.setCachedQueryData({ getTask: { id } }, result);
              obs.next(result);
            },
            error => {
              this.utilsProvider.handleAPIError(error);
            }
          );
        });
      }
    });
  }

  public updateTask(task: Task, loader?: any, complete?: boolean) {
    task = this.utils.removeNulls(task);
    task = this.removeHttpFromOnboardingUrlTask(task);
    // takes a task and updates it
    return Observable.create(obs => {
      this.authProvider.getOptions().subscribe(options => {
        let api = ENV.api + '/api/tasks/' + task.id;
        this.http.put(api, task, options).subscribe(
          result => {
            this.storageProvider._clearSessionData(task.id);
            obs.next(result);
          },
          error => {
            this.utilsProvider.handleAPIError(error, true);
            loader && loader.dismiss();
            complete && obs.next();
          }
        );
      });
    });
  }

  public updateTaskPartial(id: string, partial: any, notes?: any[], complete?: boolean) {
    return Observable.create(obs => {
      this.authProvider.getOptions().subscribe(options => {
        let api = ENV.api + '/api/tasks/' + id;
        this.http.get(api, options).subscribe(
          taskResult => {
            if (partial.install && (taskResult as any).install) {
               partial.install = {
                ...(taskResult as any).install,
                ...partial.install
              };
            }
            const task = { ...taskResult, ...partial };
            if (notes) {
              // if has notes add to notes
              task.notes = task.notes ? [...task.notes, ...notes] : [...notes];
            }
            // task['tryfail'] = true;
            if (task.address && !task.address.building) delete task.address.building;

            if (!task.install.activationPassword && task.install.serial.includes('FIRE') && complete) {
              task.install.activationPassword = localStorage.getItem('lastPass');
            }

            let cleanTask = this.utils.removeNulls(task);
            cleanTask = this.removeHttpFromOnboardingUrlTask(cleanTask);
            // update: PUT
            this.http.put(api, cleanTask, options).subscribe(
              result => {
                this.storageProvider._clearSessionData(id);
                obs.next(result);
              },
              error => {
                this.utilsProvider.handleAPIError(error);
                obs.error(error);
              }
            );
          },
          error => {
            this.utilsProvider.handleAPIError(error);
            obs.error(error);
          }
        );
      });
    });
  }

  public setSelectedTask(task: TaskQL) {
    this.selectedTask = task;
  }

  public getSelectedTask(): TaskQL {
    return this.selectedTask;
  }

  public updateTaskData(task: TaskQL, type: string, data: any) {
    /* Update the stored data of the tasks */
    if (!this.tasksData[task.id]) {
      this.tasksData[task.id] = {};
    }

    this.tasksData[task.id][type] = data;
    const thisUpdate = this.tasksData[task.id];
    this.storage.set('tasksData', this.tasksData);
    
    /* Update the storage */
    return Observable.create(observer => {
      observer.next(this.tasksData[task.id]); 
    });
  }

  public hideTask(taskId: string) {
    /* Update the stored for this task */
    return Observable.create(observer => {
      this.hiddenTasks.push(taskId)
      this.storage.set('hiddenTasks', this.hiddenTasks).then((value: any) => {
        observer.next(this.hiddenTasks);
      });
    });
  }

  public isHiddenTasks(id: string) {
    return this.hiddenTasks.includes(id);
  }

  public getTaskData(id: string) {
    return this.tasksData && this.tasksData[id] ? this.tasksData[id] : {};
  }

  public hasTaskDiagnosticTestsBeenSkipped(taskId: string) {
    return Observable.create(observer => {
      const api = ENV.api + `/sensor-desk/tasks/` + taskId + `/override-status`;
      this.authProvider.getOptions().subscribe(options => {
        this.http.get(api, options).subscribe(
          result => {
            observer.next(result);
          },
          error => {
              console.log('API error',error);
              observer.error(error);
          }
        );
      });
    });
  }
  
  addNote(taskQL: TaskQL, newNote: string): Observable<any> {
    return Observable.create(obs => {
      const userData: User = this.authProvider.userData.data as User;
      let note = {
        timestamp: new Date().getTime(),
        note: newNote,
        userId: userData.uid
      };

      this.getTask(taskQL.id).subscribe((taskResult: Task) => {
        if (!taskResult.notes) {
          taskResult.notes = new Array();
        }

        if (newNote && (newNote.length > 0)) {
          taskResult.notes.push(note);
        }

        this.updateTask(taskResult).subscribe(
          updateResult => {
            if(updateResult.notes.length > 0) this.setSelectedTask(updateResult);
            obs.next(updateResult);
            obs.complete();
          },
          error => {
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }

  declineTask(taskQL: TaskQL, reason: string, ): Observable<any> {
    return Observable.create(obs => {
      const userData: User = this.authProvider.userData.data as User;
      const username = userData.userName ?  userData.userName : userData.firstName + " " + userData.lastName;
      let note = {
        timestamp: new Date().getTime(),
        note: 'Declined by user: ' + username,
        userId: userData.uid
      };
      if (reason) {
        note.note += ': ' + reason;
      }

      this.getTask(taskQL.id).subscribe((taskResult: Task) => {
        if (!taskResult.notes) {
          taskResult.notes = new Array();
        }

        if (note) {
          taskResult.notes.push(note);
        }

        taskResult.schedulerMeta.expiredTime = null;
        taskResult.schedulerMeta.acceptedSchedulerSnn = null;
        taskResult.schedulerRejectingTask = true;
        this.updateTask(taskResult).subscribe(
          updateResult => {
            obs.next(updateResult);
            obs.complete();
          },
          error => {
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }

  checkTaskAvailability(schedulerMeta: any, uid: string) {
    let flag = true;
    if (schedulerMeta && schedulerMeta.acceptedSchedulerSnn && schedulerMeta.acceptedSchedulerSnn !== uid) {
      const hasRemainingTime = schedulerMeta?.expiredTime > new Date().getTime();
      if (hasRemainingTime) {
        flag = false;
      }
      
    }
    if (schedulerMeta && schedulerMeta.acceptedSchedulerSnn && schedulerMeta.acceptedSchedulerSnn === uid) {
      const hasRemainingTime = schedulerMeta?.expiredTime > new Date().getTime();
      if (!hasRemainingTime) {
        flag = false;
      }
    }
    return flag
  }

  acceptTask(taskQL: TaskQL, expireHours?: number, complete?: boolean): Observable<any> {
    // TODO: add user model data
    //       task update
    return Observable.create(obs => {
      const userData: User = this.authProvider.userData.data as User;
      const schedulerSnn = userData.uid;
      const nonPCCompanies = userData.companies?.filter(company => !company.startsWith('snn:group:company:plumber-connect-'));
      const companyName = this.utilsProvider.groupSnnToName(nonPCCompanies[0]);
      let notes = [];
      if (taskQL.schedulerMeta !== null && taskQL.schedulerMeta?.acceptedSchedulerSnn !== null && taskQL.schedulerMeta?.acceptedSchedulerSnn != schedulerSnn) {
        // var prevSchedulerUserData
        var expiryNote = {
          timestamp: taskQL.schedulerMeta.expiredTime,
          note: 'Job returned to pool: timeout',
          userId: taskQL.schedulerMeta?.acceptedSchedulerSnn
        }
        notes.push(expiryNote);
      }
      let note = {
        timestamp: new Date().getTime(),
        note: 'Accept Company: ' + companyName,
        userId: userData.uid
      };
      notes.push(note);

      this.getTask(taskQL.id).subscribe((taskResult: Task) => {
        //taskResult.status = Task.StatusEnum.Unscheduled;
        //delete taskResult.assignedDate;
        var expireTime = new Date().getTime() + this.allowedContactTime;
        if (!taskResult.notes) {
          taskResult.notes = new Array();
        }
        const oldNotes = taskResult.notes;
        taskResult.notes = oldNotes.concat(notes);
        const schedulerMeta = {
          expiredTime: expireTime,
          acceptedSchedulerSnn: schedulerSnn,
        }
        taskResult.schedulerMeta = schedulerMeta;
        this.updateTask(taskResult, undefined, complete).subscribe(
          updateResult => {
            obs.next(updateResult);
            obs.complete();
            // TODO: remove from cache
            // this.removeFromTasks(id).subscribe(result => {
            //   console.log('got result from task remove');
            // });
          },
          error => {
            // obs.error('could not update');
            obs.next(taskResult);
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }

  cancelTaskRest(id: string, reason: string, attachments?: Array<any>, hasNewSerial?: any) {
    const userData: User = this.authProvider.userData.data as User;
    const username = userData.userName ?  userData.userName : userData.firstName + " " + userData.lastName;
    let note = 'Cancelled by user: ' + username;

    if (reason) {
      note += ': ' + reason;
    }

    if (attachments && attachments.length > 0) {
      note += ':<br>' + this.utilsProvider.toHTMLlinks(attachments);
    }
    
    return Observable.create(observer => {
      // api/tasks/:id (DELETE)
      const api = hasNewSerial ? ENV.api + '/api/tasks/' + id + '/cancel-during-swapout' : ENV.api + '/api/tasks/' + id + '/cancel';
      this.authProvider.getOptions().subscribe(options => {
        const req = this.http.post(api, {reason: note}, options);
        req.subscribe(
          result => {
            // posted to cancel task api
            this.storageProvider._clearSessionData(id);
            observer.next(result);
            observer.complete();
            // update task after cancel here
          },
          error => {
            console.log('error',error);
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }

  public setTaskData(task: TaskQL, val: string, data: any) {
    return Observable.create(obs => {
      // TODO: save to cache (storage)
      obs.next('continue here');
    });
  }

  public setTask(task: Task) {}

  syncTask(taskData: TaskData, task: TaskQL): Observable<any> {
    let attachments = [];
    return Observable.create(observer => {
      observer.next({
        title: 'Uploading Images',
        message: 'image 1',
        percent: 10
      });
      if (task.deviceType !== 'firealarm' && taskData.photos && taskData.photos.length > 0) {
        //upload images
        const photos = [...taskData.photos].filter(pic => pic.data)
        this.utilsProvider.uploadImages(photos, 0, null, task.id).subscribe(
          response => {
            this.storageProvider._clearSessionData(task.id);
            attachments.push(response.data);
            observer.next({
              title: 'Uploading Images',
              message: 'image ' + (response.id + 2).toString(),
              percent: (response.id + 1) * 20
            });
          },
          error => {
            let message = 'Images could not be uploaded. Please try again.';
            let alert = this.alertCtrl.create({
              title: 'Error!',
              message: message,
              buttons: ['OK']
            });
            alert.present();
            observer.error(error);
          },
          () => {
            this.syncUpdatingTask(observer, task, taskData, attachments);
          }
        );
      } else {
        this.syncUpdatingTask(observer, task, taskData, attachments);
      }
    });
  }

  syncUpdatingTask(observer, task: TaskQL, taskData: TaskData, attachments: any[]) {
    observer.next({ title: 'Updating Task', message: '...' });

    if(task.type !== 'installation' && task.deviceType === 'geyser'){
      attachments = this.dummyFireData(attachments)
    }
    let hasSerial = task.install.serial ? task.install.serial : null;
    let partial = {
      completedDate: new Date().getTime(),
      status: 'closed',
      install: {
        activationPassword: '',
        questionsAnswers: taskData.questions? this.parseQA(taskData.questions): [],
        customerFeedback: taskData.feedback ? taskData.feedback : '',
        images: attachments,
        serial: hasSerial
      }
    };
    if (taskData.code && taskData.code.includes('=')) {
      partial.install.activationPassword = taskData.code.substring(taskData.code.indexOf('=') + 1);
    }

    let notes = [];
    if (taskData.comments) {
      for (let i = 0; i < taskData.comments.length; i++) {
        let comment = taskData.comments[i];
        if (comment && comment.length > 0) {
          let note = {
            timestamp: new Date().getTime(),
            note: '#image' + (i + 1) + ': ' + comment,
            userId: this.authProvider.getUserId
          };
          notes = new Array();
        }
      }
    }

    if (taskData.newSerial && taskData.deviceReplace) {
      partial.install['newSerial'] = taskData.newSerial;
    }

    if (taskData.code && taskData.code.includes(';')) {
      const pass = taskData.code.substring(taskData.code.indexOf(';') + 5);
      partial.install.activationPassword = pass;
    }

    observer.next({
      title: 'Updating',
      message: 'Sending',
      percent: 90
    });

    if (taskData && taskData.feedback && (taskData.feedback.length > 0)){
      const userData: User = this.authProvider.userData.data as User;
      let note = {
        timestamp: new Date().getTime(),
        note: taskData.feedback,
        userId: userData.uid
      };
      notes.push(note)
    }

    this.updateTaskPartial(task.id, partial, notes, true).subscribe(
      updateResult => {
        observer.next({
          title: 'Updating',
          message: 'done',
          percent: 100
        });
        observer.complete();
      },
      error => {
        partial.status = 'inprogress';
        observer.error(error);
      }
    );
  }

  parseQA(obj) {
    let qaObj: Array<any> = [];
    for (let i = 0; i < obj.length; i++) {
      let question = obj[i].label ? obj[i].label : obj[i].title;
      let answers = obj[i].options ? obj[i].options : obj[i].answers;
      let answer = '';
      let value: any = '';
      if (!obj.hidden) {
        if (obj[i].type === 'input') {
          answer = obj[i].value;
          value = obj[i].value;
        } else {
          answers.map(ans => {
            if (ans.selected) {
              answer = (answer && (answer.length > 0)) ? answer + ", " + ans.title : ans.title;
              value = (value && (value.length > 0)) ? value + ", " + ans.value : ans.value;
            }
          });
        }
      }

      qaObj.push({
        question: question,
        answer: answer,
        tag: obj[i].tag,
        value: value
      });
    }
    return qaObj;
  }

  dummyFireData(attachments){
    const dummyPics = {
      comment: "",
      label: "",
      src: "sn-sensordesk-images-development.s3.eu-west-1.amazonaws.com/images/20210915132621-snn_account_6-1.jpg",
      tag: "Test"
    }
    if(attachments.length < 1){
      attachments = [dummyPics]
    }
    return attachments;
  }

  removeHttpFromOnboardingUrlTask(obj){
   const onboardingUrl =  getValue(obj,'companyReference.meta.geyser:contact.onboardingUrl');
    if(onboardingUrl){
      obj.companyReference.meta["geyser:contact"].onboardingUrl = onboardingUrl.replace('http://','');
    }

    obj.notes =  obj.notes.map(note => {
      note.note = note.note.replaceAll("http://", '').replaceAll("https://", '');
      return note;
    });
    return obj;
  }

  checkInstallerAvailability(params: GetTechnicianAvailabilityPayloadInput) {
    return Observable.create(observer => {
      const api = ENV.api + `/api/users/booking-availability/${params.snn}/${params.date}`;
      this.authProvider.getOptions().subscribe(options => {
        this.http.get(api, options).subscribe(
          result => {
            observer.next(result);
          },
          error => {
            console.log('API error',error);
            observer.error(error);
          }
        );
      });
    });
  }

  public postTaskListForUser(filters?: any) {
    return Observable.create((obs:any) => {
      const hasQueryBeenCalledBefore = this.storageProvider.hasQueryBeenCalledBefore({ postTaskListForUser: {...filters} });
      if (hasQueryBeenCalledBefore) { 
        console.log("Returning cached data", hasQueryBeenCalledBefore);
        obs.next(hasQueryBeenCalledBefore);

      } else {
        this.authProvider.getOptions().subscribe(options => {
          let api = ENV.base + '/sensor-desk/users/get-tasks';
          this.http.post(api, {...filters, limit: 20}, options).subscribe(
            result => {
              this.storageProvider.setCachedQueryData({ postTaskListForUser: {...filters} }, result);
              obs.next(result);
            },
            error => {
              this.utilsProvider.handleAPIError(error);
            }
          );
        });
      }
    });
  }

  public getTaskListCount(filters:any) {
    return Observable.create((obs:any) => {
      this.authProvider.getOptions().subscribe((options:any) => {
        let api = ENV.base + '/sensor-desk/users/get-tasks/count';
        this.http.post(api, filters, options).subscribe(
          result => {
            console.log("Task list count", result);
            obs.next(result);
          },
          error => {
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/tasks/tasks.ts